<script setup>
import ChartBar from '../chart/ChartBar.vue'
import FilterSetting from '~/components/data-filters/FilterSetting.vue'
import { useStationDataStore } from '~/stores/stations'
import AppLoadingWrapper from '~/components/app/AppLoadingWrapper.vue'
import DataItem from '~/components/data-views/DataItem.vue'
import CardStat from '~/components/card/CardStat.vue'
import CardStatWrapper from '~/components/layout/CardStatWrapper.vue'

const stationStore = useStationDataStore()
const stationsGroupedByFuelTypeArray = computed(() => {
  return stationStore.getExistingStationCountGropedByFuelType.map((item) => ({
    label: item.fuelType.title,
    value: item.stationCount,
  }))
})

const stationsGroupedByCategoryArray = computed(() => {
  return stationStore.getFilteredStationsGroupeByCategory.map((item) => ({
    label: item.category.title,
    value: item.stations.length,
  }))
})
const stationsGroupedByType = computed(() => stationStore.getStationsGroupedByType)
const outletCount = computed(() => {
  if (stationsGroupedByType.value)
    return Object.values(stationsGroupedByType.value).reduce((acc, item) => {
      return acc + item.outletCount
    }, 0)
})
const electricityOrigin = computed(() => stationStore.getElectrictyOrigin)

const filterSettings = computed(() => stationStore.filterSettings)
</script>
<template>
  <FilterSetting
    content-type="station"
    :setting="filterSettings.stationCategories"
    class="my-4 sm:mr-4"
  />
  <Divider />
  <CardStatWrapper>
    <CardStat
      label="Befintliga stationer"
      :value="stationsGroupedByType?.existing?.stations?.length"
    />
    <CardStat
      label="Planerade stationer"
      :value="stationsGroupedByType?.planned?.stations?.length"
    />
    <CardStat label="Antal uttag" :value="outletCount" />
  </CardStatWrapper>
  <AppLoadingWrapper :is-loading="stationsGroupedByFuelTypeArray.length === 0" :height="100">
    <DataItem
      title="Fördelat på kapacitet"
      description="Diagrammet visar det totala antalet stationer uppdelat per kapacitetskategori. Notera att en station kan räknas flera gånger om den tillhör mer än en kategori."
    >
      <ChartBar :data="stationsGroupedByCategoryArray" direction="horizontal" />
    </DataItem>
    <DataSource
      :source-data="[
        { identifier: electricityOrigin },
        { identifier: 'energimyndigheten' },
        { identifier: 'trafikverket' },
        { identifier: 'klimatklivet' },
      ]"
    />
  </AppLoadingWrapper>
</template>
